import React from 'react';
import { Table } from "react-bootstrap";
import { Link } from 'react-router-dom';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import Spinner from 'layouts/public/spinner/Spinner'

class DiscountCategorySummary extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
        return {
			loading: true,
			discountCategories: [],
			amountUsedByVOBs: null
		};
    }

    componentDidMount() {
		this.get();
    }

	get = () => {
        new API().post(APIModules.Admin.url('/discountCodeDashboard/getDiscountCategorySummary'), null,
            {
                success: (r) => {
                    this.setState({ discountCategories: r.data.items, loading: false, amountUsedByVOBs: r.data.amountUsedByVOBs });
                }
			});

    }

	getDiscountCodeExecutiveReport = () => {
		new API().post(APIModules.Admin.url('/discountCodeDashboard/getDiscountCodeExecutiveReportExport'), null,
			{
				success: (sr) => {
					new API().download(sr.data);
				}
			});
	}

	renderDiscountCategories = () => {

		let items = [];

		this.state.discountCategories.forEach((dc) => {
			items.push(
				<tr key={dc.discountCategoryCode}>
					<td className="react-grid-Cell">{dc.description}</td>
					<td className="react-grid-Cell">
						{dc.total > 0 ?
							<Link to={'/admin/discountCodeSetup?active=true&discountCategoryCode=' + dc.discountCategoryCode + "&discountCategoryName=" + encodeURIComponent(dc.description)}>
								{dc.total}
							</Link>
						:
							<span>-</span>
						}
					</td>
				</tr>
			);
		});

		items.push(
			<tr key="Total">
				<td className="react-grid-Cell"><b>Amount Used by VOB's</b></td>
				<td className="react-grid-Cell">
					{this.state.amountUsedByVOBs > 0 ?
						<Link to="#" onClick={this.getDiscountCodeExecutiveReport}>{this.state.amountUsedByVOBs}</Link>
					:
						<span>{this.state.amountUsedByVOBs}</span>
					}	
				</td>
			</tr>
		);

		return items;
	}

	render() {
		if (this.state.loading)
			return <Spinner />

		return (
			<Table condensed>
				<thead>
					<tr>
						<th className="col-md-2">Discount Category</th>
						<th className="col-md-2">Total</th>
					</tr>
				</thead>
				<tbody>
					{this.renderDiscountCategories()}
				</tbody>
			</Table>
		)
	}
}

export default DiscountCategorySummary;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/adminDiscountCodeDashboard/discountCategorySummary/DiscountCategorySummary.js